import * as yup from 'yup'
import { naturalPersonsInputs } from '../../../constants/naturalPersonsPage'

const requireStr = yup.string().required("Це обов'язкове поле")

export const schema: yup.SchemaOf<naturalPersonsInputs> = yup.object().shape({
	name: requireStr,
	lastname: requireStr,
	surname: yup.string().nullable(),
	email: requireStr.email('Некоректна електронна адреса'),
	phone: requireStr.matches(/^(\d{12})$/, 'Номер повинен бути у форматі 380961111111'),
	inn: yup.string().nullable(),
	birthdate: yup.date().max(new Date(), 'Некоректна дата').nullable().transform((value, originalValue) => (originalValue === '' ? null : value)),
	passport: yup.string().nullable(),
	registration: yup.string().nullable(),
	status: yup.boolean().nullable(),
	discountPerLiter: yup.number().nullable(),
})
